"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withModalViewContext = exports.default = exports.ModalViewContext = exports.ModalView = exports.CLOSE_TIMEOUT_MS = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactModal = _interopRequireDefault(require("react-modal"));
var _reactRouterDom = require("react-router-dom");
var _openPrevEditor = require("@catalytic/catalytic-icons/lib/glyphs/open-prev-editor.svg");
var _recompose = require("recompose");
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/styles");
var _utils = require("@material-ui/utils");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _Text = require("../../Text/Text");
var _excluded = ["appElement", "bodyOpenClassName", "children", "classes", "className", "closeTimeoutMS", "contentClassName", "data", "intl", "isOpen", "onAfterOpen", "openElement", "onRequestClose", "overlayClassName", "overlayRef", "portalClassName", "shouldCloseOnOverlayClick", "shouldCloseOnOverlayClickPrompt", "theme", "trigger"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var CLOSE_TIMEOUT_MS = exports.CLOSE_TIMEOUT_MS = 200;
var DISPLAY_NAME = 'ModalView';
var IS_OPEN = false;
var Style = function Style(theme /*: ThemeType*/) {
  return {
    '@keyframes slideInUp': {
      from: {
        transform: 'translate3d(0, 12rem, 0)'
      },
      to: {
        transform: 'translate3d(0, 0, 0)'
      }
    },
    '@keyframes slideOutDown': {
      from: {
        transform: 'translate3d(0, 0, 0)'
      },
      to: {
        transform: 'translate3d(0, 12rem, 0)'
      }
    },
    bodyOpen: theme.mixins.bodyOpen,
    modal: (0, _defineProperty2.default)({
      position: 'absolute',
      top: theme.functions.toRem(theme.variables.modalTop),
      right: 0,
      bottom: 0,
      left: 0,
      paddingBottom: theme.functions.toRem(theme.variables.modalMobilePadding),
      borderTopLeftRadius: theme.variables.borderRadius,
      borderTopRightRadius: theme.variables.borderRadius,
      backgroundColor: theme.colors.white,
      boxShadow: "0 .125rem .25rem ".concat(theme.colors.battleshipGreyAlpha),
      animationDuration: function animationDuration(_ref) {
        var _ref$closeTimeoutMS = _ref.closeTimeoutMS,
          closeTimeoutMS = _ref$closeTimeoutMS === void 0 ? CLOSE_TIMEOUT_MS : _ref$closeTimeoutMS;
        return "".concat(closeTimeoutMS, "ms");
      },
      animationTimingFunction: 'ease-in-out',
      animationFillMode: 'both',
      transform: 'translate3d(0, 0, 0)'
    }, theme.breakpoints.desktop, {
      margin: 'auto',
      paddingBottom: theme.functions.toRem(theme.variables.modalDesktopPadding),
      maxWidth: '100%',
      width: function width(_ref2) {
        var _ref2$width = _ref2.width,
          _width = _ref2$width === void 0 ? 'medium' : _ref2$width;
        return theme.functions.toRem(_width === 'large' ? theme.variables.modalWidthLarge : theme.variables.modalWidthMedium);
      }
    }),
    modalOpen: {
      animationName: '$slideInUp'
    },
    modalClose: {
      animationName: '$slideOutDown'
    },
    modalButton: {
      display: 'block',
      margin: '0 auto',
      padding: 0,
      width: theme.functions.toRem(theme.variables.button),
      height: theme.functions.toRem(theme.variables.button),
      backgroundColor: 'transparent',
      '&:before': {
        content: '""',
        display: 'block',
        margin: '0 auto',
        width: theme.functions.toRem(theme.variables.modalTop),
        height: theme.variables.borderRadiusSmall,
        borderRadius: theme.variables.borderRadiusSmall,
        backgroundColor: theme.colors.pastelGrey
      }
    },
    modalContent: (0, _defineProperty2.default)({
      overflow: 'auto',
      height: '100%',
      padding: "0 ".concat(theme.functions.toRem(theme.variables.modalMobilePadding), " ").concat(theme.functions.toRem(theme.variables.button))
    }, theme.breakpoints.desktop, {
      padding: "0 ".concat(theme.functions.toRem(theme.variables.modalDesktopPadding), " ").concat(theme.functions.toRem(theme.variables.button))
    }),
    overlay: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: theme.colors.battleshipGreyAlpha,
      animationDuration: function animationDuration(_ref3) {
        var _ref3$closeTimeoutMS = _ref3.closeTimeoutMS,
          closeTimeoutMS = _ref3$closeTimeoutMS === void 0 ? CLOSE_TIMEOUT_MS : _ref3$closeTimeoutMS;
        return "".concat(closeTimeoutMS, "ms");
      },
      animationTimingFunction: 'ease-in-out',
      animationFillMode: 'both',
      opacity: 1
    },
    overlayOpen: {
      animationName: theme.variables.fadeIn
    },
    overlayClose: {
      animationName: theme.variables.fadeOut
    },
    portal: {
      position: 'fixed',
      zIndex: theme.zIndex.modal
    },
    portalOpen: {
      '& ~ $portalOpen': {
        '& $modal': (0, _defineProperty2.default)({
          marginTop: '0.5rem'
        }, theme.breakpoints.desktop, {
          width: theme.functions.toRem(theme.variables.modalWidt + theme.variables.base)
        })
      }
    },
    portalClose: {}
  };
};
/*:: export type Hide = (event: SyntheticEvent<*> | void) => void;*/
/*:: export type Show = (event: SyntheticEvent<*> | void) => void;*/
/*:: export type ModalViewTriggerProps = {|
  hide: Hide,
  isClosing: boolean,
  isOpening: boolean,
  isOpen: boolean,
  show: Show
|};*/
/*:: export type ModalViewTrigger =
  | React.Node
  | ((props: ModalViewTriggerProps) => React.Node);*/
/*:: export type ModalViewProps = {
  appElement?: HTMLElement | null,
  bodyOpenClassName?: string,
  children?: React.Node | ((props: ModalViewTriggerProps) => React.Node),
  closeTimeoutMS?: number,
  contentClassName?: string,
  data?: { [string]: string },
  isOpen?: boolean,
  modalButtonRef?: React.ElementRef<*>,
  onAfterOpen?: (event: SyntheticEvent<*> | void) => void,
  openElement?: React.Element<typeof Link> | React.Element<'a'>,
  onRequestClose?: (event: SyntheticEvent<*> | void) => boolean | void,
  overlayClassName?: string,
  overlayRef?: React.ElementRef<*>,
  portalClassName?: string,
  shouldCloseOnOverlayClick?: boolean,
  shouldCloseOnOverlayClickPrompt?: string,
  trigger?: ModalViewTrigger,
  width?: 'medium' | 'large'
};*/
/*:: type BaseProps = InjectSheetProvidedProps & ModalViewProps & { intl: Object };*/
/*:: type DefaultProps = {
  appElement: HTMLBodyElement,
  closeTimeoutMS: number,
  isOpen: boolean
};*/
/*:: type State = {
  isClosing: boolean,
  isOpen: boolean,
  isOpening: boolean
};*/
var ModalViewContext /*: React.Context<boolean>*/ = exports.ModalViewContext = React.createContext(false);
var withModalViewContext = exports.withModalViewContext = function withModalViewContext(WrappedComponent /*: React.ComponentType<*>*/) {
  // Convention: Wrap the Display Name for Easy Debugging
  // https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
  var WithModalViewContext = /*#__PURE__*/function (_React$Component) {
    function WithModalViewContext() {
      (0, _classCallCheck2.default)(this, WithModalViewContext);
      return _callSuper(this, WithModalViewContext, arguments);
    }
    (0, _inherits2.default)(WithModalViewContext, _React$Component);
    return (0, _createClass2.default)(WithModalViewContext, [{
      key: "render",
      value: function render() {
        var _this = this;
        return /*#__PURE__*/React.createElement(ModalViewContext.Consumer, null, function (context) {
          return /*#__PURE__*/React.createElement(WrappedComponent, (0, _extends2.default)({}, _this.props, {
            modalViewContext: context
          }));
        });
      }
    }]);
  }(React.Component);
  WithModalViewContext.displayName = "WithModalViewContext(".concat((0, _utils.getDisplayName)(WrappedComponent), ")");
  return WithModalViewContext;
};
var ModalView = exports.ModalView = /*#__PURE__*/function (_React$PureComponent) {
  function ModalView() {
    var _this2;
    (0, _classCallCheck2.default)(this, ModalView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ModalView, [].concat(args));
    (0, _defineProperty2.default)(_this2, "state", {
      isClosing: false,
      isOpen: _this2.props.isOpen || IS_OPEN,
      isOpening: false
    });
    (0, _defineProperty2.default)(_this2, "_isMounted", false);
    (0, _defineProperty2.default)(_this2, "_timeout", null);
    (0, _defineProperty2.default)(_this2, "modalButtonRef", void 0);
    (0, _defineProperty2.default)(_this2, "overlayRef", void 0);
    (0, _defineProperty2.default)(_this2, "handleAfterOpen", function (event /*: SyntheticEvent<*> | void*/) {
      var _this2$props = _this2.props,
        closeTimeoutMS = _this2$props.closeTimeoutMS,
        onAfterOpen = _this2$props.onAfterOpen;
      if (_this2._isMounted) {
        _this2.setState({
          isOpen: true,
          isOpening: true
        });
      }
      _this2._timeout = setTimeout(function () {
        _this2._timeout = null;
        if (_this2._isMounted) {
          _this2.setState({
            isOpening: false
          });
        }
        if (onAfterOpen) {
          onAfterOpen(event);
        }
      }, closeTimeoutMS);
    });
    (0, _defineProperty2.default)(_this2, "handleRequestClose", function (event /*: SyntheticEvent<*> | void*/) {
      var _this2$props2 = _this2.props,
        closeTimeoutMS = _this2$props2.closeTimeoutMS,
        onRequestClose = _this2$props2.onRequestClose,
        shouldCloseOnOverlayClickPrompt = _this2$props2.shouldCloseOnOverlayClickPrompt;
      if (event && (0, _typeof2.default)(event) === 'object' && (event.target === _this2.overlayRef || event.target === _this2.modalButtonRef) && shouldCloseOnOverlayClickPrompt && window.confirm(shouldCloseOnOverlayClickPrompt) === false) {
        return;
      }
      if (onRequestClose) {
        var _shouldCloseOnOverlayClickPrompt = onRequestClose(event);
        if (_shouldCloseOnOverlayClickPrompt === false) {
          return;
        }
      }
      if (_this2._isMounted) {
        _this2.setState({
          isClosing: true
        });
      }
      _this2._timeout = setTimeout(function () {
        _this2._timeout = null;
        if (_this2._isMounted) {
          _this2.setState({
            isClosing: false,
            isOpen: false
          });
        }
      }, closeTimeoutMS);
    });
    return _this2;
  }
  (0, _inherits2.default)(ModalView, _React$PureComponent);
  return (0, _createClass2.default)(ModalView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        appElement = _this$props.appElement,
        bodyOpenClassName = _this$props.bodyOpenClassName,
        children = _this$props.children,
        classes = _this$props.classes,
        className = _this$props.className,
        closeTimeoutMS = _this$props.closeTimeoutMS,
        contentClassName = _this$props.contentClassName,
        data = _this$props.data,
        intl = _this$props.intl,
        isOpenProp = _this$props.isOpen,
        onAfterOpen = _this$props.onAfterOpen,
        openElement = _this$props.openElement,
        onRequestClose = _this$props.onRequestClose,
        overlayClassName = _this$props.overlayClassName,
        overlayRef = _this$props.overlayRef,
        portalClassName = _this$props.portalClassName,
        shouldCloseOnOverlayClick = _this$props.shouldCloseOnOverlayClick,
        shouldCloseOnOverlayClickPrompt = _this$props.shouldCloseOnOverlayClickPrompt,
        theme = _this$props.theme,
        trigger = _this$props.trigger,
        other = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var _this$state = this.state,
        isClosing = _this$state.isClosing,
        isOpenState = _this$state.isOpen,
        isOpening = _this$state.isOpening;
      var isOpen = isOpenState || isOpenProp || IS_OPEN;
      var isAnimating = isClosing || isOpening;
      var triggerProps /*: ModalViewTriggerProps*/ = {
        hide: this.handleRequestClose,
        isClosing: isClosing,
        isOpen: isOpen,
        isOpening: isOpening,
        show: this.handleAfterOpen
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, typeof trigger === 'function' ? trigger(triggerProps) : trigger, /*#__PURE__*/React.createElement(_reactModal.default, (0, _extends2.default)({
        aria: {
          modal: true
        },
        bodyOpenClassName: (0, _classnames.default)(classes.bodyOpen, bodyOpenClassName),
        className: (0, _classnames.default)(classes.modal, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.modalOpen, isOpen), classes.modalClose, isClosing || !isOpen), className),
        onRequestClose: this.handleRequestClose,
        overlayClassName: (0, _classnames.default)(classes.overlay, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.overlayOpen, isOpen), classes.overlayClose, isClosing || !isOpen), overlayClassName),
        overlayRef: function overlayRef(node) {
          return _this3.overlayRef = node;
        },
        shouldCloseOnOverlayClick: !isAnimating,
        portalClassName: (0, _classnames.default)(classes.portal, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.portalOpen, isOpen), classes.portalClose, isClosing || !isOpen), portalClassName),
        tabIndex: -1,
        testId: "modal"
      }, _objectSpread({
        appElement: appElement,
        closeTimeoutMS: closeTimeoutMS,
        data: data,
        isOpen: isOpen
      }, other)), isOpen && !isAnimating && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
        "aria-label": intl.formatMessage({
          id: 'modal.hide',
          defaultMessage: 'Close'
        }),
        className: classes.modalButton,
        "data-testid": "close",
        onClick: this.handleRequestClose,
        ref: function ref(node) {
          return _this3.modalButtonRef = node;
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: (0, _classnames.default)(classes.modalContent, contentClassName)
      }, openElement && React.cloneElement(openElement, {
        children: /*#__PURE__*/React.createElement(OpenAsPage, null)
      }), /*#__PURE__*/React.createElement(ModalViewContext.Provider, {
        value: true
      }, typeof children === 'function' ? children(triggerProps) : children)))));
    }
  }]);
}(React.PureComponent);
(0, _defineProperty2.default)(ModalView, "displayName", DISPLAY_NAME);
(0, _defineProperty2.default)(ModalView, "defaultProps", {
  appElement: window.document.body,
  closeTimeoutMS: CLOSE_TIMEOUT_MS,
  isOpen: IS_OPEN
});
var useOpenAsPageStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    root: {
      alignItems: 'center',
      cursor: 'pointer',
      display: 'inline-flex',
      position: 'absolute',
      top: '0.875rem',
      color: theme.colors.battleshipGrey
    },
    icon: {
      marginRight: '0.375rem'
    }
  };
});
var OpenAsPage = function OpenAsPage() {
  var classes = useOpenAsPageStyles();
  return /*#__PURE__*/React.createElement(_Text.ExtraSmallText, {
    className: classes.root
  }, /*#__PURE__*/React.createElement(_openPrevEditor.ReactComponent, {
    className: classes.icon
  }), /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "Open as page",
    id: "open.button"
  }));
};
var _default = exports.default = ((0, _recompose.compose)((0, _recompose.setDisplayName)(DISPLAY_NAME), _reactIntl.injectIntl, (0, _injectSheet.default)(Style))(ModalView) /*: React.ComponentType<ModalViewProps>*/);
//# sourceMappingURL=ModalView.js.map